import { createStructuredSelector } from 'reselect'
import { getCurrentUserId } from './currentUserGetters'

const getStep = state => state.dialog.invitation?.data?.step

export default createStructuredSelector({
  currentUserId: getCurrentUserId,
  step: getStep
})
